module.exports = __webpack_public_path__ + "img/MGH-Gaien-4.94501358.jpg";